import queryString from "query-string";
import { config } from "../config";

export const getParameterByName = (url, name) => {
    const match = RegExp('[?&]' + name + '=([^&]*)').exec(url);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

export const objectToQueryString = (object) => {
    Object.keys(object).forEach(function (key) {
        if (object[key] === undefined || object[key] === null) {
            delete object[key];
        }
    });

    return new URLSearchParams(object)
}


export const decodeLiffState = (liffStateEncoded) => {
    try {
        if (!liffStateEncoded) throw new Error('Missing liff.state');

        // Decode liff.state (e.g., "?data=...")
        const data = queryString.parse(liffStateEncoded.replace(/^\?/, ''));

        return data;
    } catch (error) {
        console.error('Error decoding liff.state:', error.message);
        return null;
    }
}

export const getEkycPageURL = (idCard, system, callback) => {
    return `${config.ekyc_fe_url}?id_number=${idCard}&system=${encodeURI(system)}&callback=${encodeURI(callback)}`;;
};